<app-header [title]="'Licensed Products'">
  <app-button
    *ngIf="canManageProducts"
    [black]="true"
    [title]="'+ Create Product'"
    (click)="navigateToCreateProduct()"
    header-button
  ></app-button>
</app-header>

<div class="toolbar">
  <div class="search-field">
    <app-input
      [placeholder]="'Search licensed products'"
      (inputValue)="onSearchChange($event)"
    ></app-input>
  </div>
  <div class="result-count" *ngIf="!licensedProductStore.loading()">
    {{ filteredProducts.length }} product{{
      filteredProducts.length === 1 ? '' : 's'
    }}
  </div>
</div>

<div class="status-card" *ngIf="licensedProductStore.loading()">
  Loading licensed products...
</div>

<div
  class="status-card"
  *ngIf="!licensedProductStore.loading() && filteredProducts.length === 0"
>
  No licensed products found.
</div>

<div
  class="list"
  *ngIf="!licensedProductStore.loading() && filteredProducts.length > 0"
>
  <app-license-product-card
    *ngFor="let product of filteredProducts; trackBy: trackByProduct"
    [product]="product"
    [showActions]="canManageProducts"
    (editProduct)="navigateToEditProduct($event)"
    (deleteProduct)="deleteProduct($event)"
  ></app-license-product-card>
</div>
